/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { ListItemStyled } from './ListItem.styles'
import { ListLinkStyled } from './ListLink.styles'

interface ListItemProps {
  to?: string
  children?: React.ReactElement | number | string | (React.ReactElement | number | string)[]
  hideChevron?: boolean
}

export const ListItem = (props: ListItemProps) => {
  if (props.to) {
    const { to, hideChevron, ...rest } = props
    return (
      <ListItemStyled {...rest}>
        <ListLinkStyled {...rest} to={to} hideChevron={hideChevron}>
          {props.children}
        </ListLinkStyled>
      </ListItemStyled>
    )
  } else {
    return <ListItemStyled {...props}>{props.children}</ListItemStyled>
  }
}
